import React from 'react';

import Avatar from 'Shared/components/Avatar/Avatar';
import AddItemButtons from 'Shared/components/AddItemButtons/AddItemButtons';
import { AvatarType } from 'Shared/constants/types';
import WpButton from 'Wpds/components/button/WpButton';
import WpIcon from 'Wpds/components/icon/WpIcon';
import EmptyStateContainer from 'Shared/components/EmptyStateContainer/EmptyStateContainer';
import { WpTabs, WpTab } from 'Wpds/components/tabs';

import './FakeWorkspaceContent.scss';

type Props = {
  workspace: {
    fullName?: string;
    avatar?: AvatarType;
    uuid: string;
  };
  currentUser: {
    fullName: string;
    avatar: AvatarType;
  };
};

function FakeWorkspaceContent({ workspace }: Props) {
  return (
    <div className="fake-workspace d-flex flex-column w-100">
      <div className="fake-workspace-title w-100 mt-4">
        <div className="d-flex w-100 align-items-center">
          <div className="workspace-title-avatar-wrapper position-relative">
            <Avatar avatar={workspace?.avatar} height={116} initialsNotSmallSize isGradientBorder />
          </div>
          <div className="d-flex w-100 flex-column flex-lg-row ml-3 ml-sm-0 mt-3 mt-sm-0">
            <div className="workspace-title-area d-flex flex-column mr-sm-3">
              <div className="workspace-title-name ">{workspace.fullName}</div>
              <div className="workspace-title-description d-flex align-items-center">
                <div className="workspace-title-description-content d-inline-block">
                  This is a private space between you and {workspace.fullName}
                </div>
              </div>
            </div>
            <div className="workspace-title-butttons d-flex align-self-start justify-content-sm-end ml-lg-auto flex-wrap">
              <WpButton icon>
                <WpIcon name="stars" />
                Give Kudos
              </WpButton>
            </div>
          </div>
        </div>
        <div className="workspace-toggle-buttons d-flex pt-2">
          <WpTabs activeTab="workspace">
            <WpTab tabId="workspace">Workspace</WpTab>
            <WpTab>Feedback & Kudos</WpTab>
            <WpTab>Goals</WpTab>
            <WpTab>Private Notes</WpTab>
          </WpTabs>
        </div>
      </div>
      <div className="fake-workspace-content">
        <div className="workspace-content-sticky-section position-sticky mb-3 mt-4 d-block d-sm-flex flex-sm-row justify-content-between">
          <h4 className="align-self-end mb-0 mt-2 mt-sm-0 mb-sm-2">Discussion Topics</h4>
          <div className="d-flex">
            <WpTabs activeTab="open">
              <WpTab tabId="open">Open Items</WpTab>
              <WpTab>Completed Items</WpTab>
            </WpTabs>
          </div>
        </div>
        <div className="discussion-topics-version-a-control-panel d-flex flex-column rounded pt-2 mb-3">
          <div>
            <AddItemButtons
              isDiscussionTopicOption
              onAddMeetingItem={() => null}
              onAddSubItem={() => null}
              onVideoRecorderToggle={() => null}
            />
          </div>
        </div>
        <EmptyStateContainer
          subTitle="Start the collaborative agenda by adding a Discussion Topic"
          button={
            <WpButton variant="tertiary">
              <WpIcon name="plus" />
              Add Topic
            </WpButton>
          }
          inContainer
        />
        <div className="action-items mt-4">
          <h4 className="action-items-title mb-0">Action Items</h4>
          <div className="mb-3 pt-2">
            <AddItemButtons
              onAddMeetingItem={() => null}
              onAddSubItem={() => null}
              onVideoRecorderToggle={() => null}
            />
          </div>
          <EmptyStateContainer
            subTitle="Keep the team on track by creating action items during, in between and after meetings."
            button={
              <WpButton variant="tertiary">
                <WpIcon name="plus" />
                Add Action Item
              </WpButton>
            }
            inContainer
          />
        </div>
      </div>
    </div>
  );
}

export default FakeWorkspaceContent;
